const enabledAccounts = 'enabledAccounts';

/** Base Fetch Actions */
export const FETCH_ENABLED_ACCOUNTS_RESPONSE =
  `${enabledAccounts}/FETCH_ENABLED_ACCOUNTS_RESPONSE` as const;
export const FETCH_ENABLED_ACCOUNTS_REQUEST =
  `${enabledAccounts}/FETCH_ENABLED_ACCOUNTS_REQUEST` as const;
export const FETCH_ENABLED_ACCOUNTS_ERROR =
  `${enabledAccounts}/FETCH_ENABLED_ACCOUNTS_ERROR` as const;
